export default __webpack_public_path__ + "static/media/affordable-pricing.2d42ea7e.webp";